
<div class="d-flex justify-content-around">
    <div class="form-group ">
        <label for="">Choisir la classe</label>
        <select class="mx-1 form-control" (change)="loadCompositions1($event)" >
            <option selected disabled></option>
            <option *ngFor="let classroom of classrooms" [value]="classroom?.id">{{classroom?.name}}</option>
        </select>
    </div>
    <div class="form-group ">
        <label for="">Choisir la période</label>
        <select class="mx-1 form-control" [(ngModel)]="periodId" name="periodId" (change)="loadCompositions2($event)">
            <option selected disabled></option>
            <option *ngFor="let p of periods" [value]="p?.id">{{p?.name}}</option>
        </select>
    </div>
    <!-- <div class="form-group ">
        <label for="">Choisir la composition</label>
        <select class="mx-1 form-control" ngModel name="composition_id" (change)="loadNotes($event)">
            <option selected disabled></option>
            <option *ngFor="let c of compositions" [value]="c?.id">{{c?.name}}</option>
        </select>
    </div> -->
</div>
<div class="text-center">
    <button *ngIf="currentCompositon?.has_note && !currentCompositon.is_confirmed" (click)="confirm()" class="btn btn-sm btn-primary">Confirmer les notes de cette composition</button>
</div>

<div class="row">
    <div class="col-12">
        <div class=" text-center border" >
            <div class="ag-bg-red  row no-gutters p-1" style="height: 3rem; border-radius: 10px 10px 0px 0px;">
                <!-- <div class="col-md-1 col-12">
                    <span class="text-white align-self-center">#</span>
                </div> -->
                <div class="col-md-5 col-12">
                    <span class="text-white align-self-center">Apprenant</span>
                </div>
                <div class="col-md-1 col-12">
                    <span class="text-white align-self-center">H.Abs.</span>
                </div>
                <div class="col-md-1 col-12">
                    <span class="text-white align-self-center">H.Rtd</span>
                </div>
                <div class="col-md-1 col-12">
                    <span class="text-white align-self-center">Moy. Elv</span>
                </div>
                <div class="col-md-1 col-12">
                    <span class="text-white align-self-center">Moy. classe</span>
                </div>
                <!-- <div class="col-md-2 col-12">
                    <span class="text-white align-self-center">+</span>
                </div> -->
                <!-- <div class="col-md-3 col-12">
                    <span class="text-white align-self-center">Eléments du programe</span>
                </div> -->
                <div class="col-md-3 col-12">
                    <span class="text-white align-self-center">Appréciation</span>
                </div>
            </div>
              
            <div class="" style="height: 65vh; overflow-y: scroll; ">
                <table class="table table-sm table-striped  table-borderless">
                    <tr class=" d-flex flex-column flex-md-row row align-items-start no-gutters px-1" *ngFor="let d of data; let i=index">
                        <!-- <td class="col-1">
                            <div class="">
                                {{i+1}}
                            </div>
                        </td> -->
                        <td class="col-md-5 col-12 ">
                            <p class="text-center text-md-left">
                                <span><strong>{{d.lastname}}</strong> </span>
                                <span> {{d.firstname}}</span>
                            </p>
                           
                        </td>
                        <td class="col-md-1 col-12">
                            {{d.missed}}
                        </td>
                        <td class="col-md-1 col-12">
                            {{d.late}}
                        </td>
                        <td class="col-md-1 col-12">
                            {{d.stu_average}}
                        </td>
                        <td class="col-md-1 col-12">
                            {{classMoy}}
                        </td>
                        <!-- <td class="col-md-3 col-12">
                            <textarea name="textbook" [(ngModel)]="d.textbook" class="form-control"></textarea>
                        </td> -->
                        <td class="col-md-3 col-12">
                            <textarea *ngIf="d.bulletin" name="appreciation" rows="2" [(ngModel)]="d.bulletin!.appreciation" class="form-control" [readonly]="!canSetAppreciation"></textarea>
                        </td>
                    </tr>
                </table>
                <div class="text-center">
                    <button *ngIf="canSetAppreciation" (click)="setGeneraleAppreciation()" class="btn btn-sm btn-primary">Enregistrer les appréciations générales</button>
                </div>
            </div>
        </div>
    </div>
</div>



<ng-template #addContent let-c="close" let-d="dismiss">
    <form #addForm="ngForm" (ngSubmit)="update(addForm.value)">
    <div class="modal-header">
      <h6 class="modal-title" id="modal-basic-title">Attribuer une nouvelle note</h6>
      <button type="button" class="btn-close" aria-label="Close" (click)="d('Cross click')"></button>
    </div>
    <div class="modal-body" >
     
            <div class="form-group">
                <input type="number" class="form-control" ngModel name="new_value" required>
            </div>
     
    </div>
    <div class="modal-footer">
        <button type="submit" class="btn btn-outline-dark" [disabled]="addForm.invalid"  >Enregistrer les notes <app-loading [isVisible]="loading"></app-loading></button>
    </div>
    </form>
  </ng-template>


  <ng-template #contentPDF let-offcanvas>
    <div class="offcanvas-header">
      
      <h4 class="offcanvas-title">Visualiseur de fichier</h4>
      <button id="closePDFBtn" type="button" class="btn-close" aria-label="Close" (click)="offcanvas.dismiss('Cross click')"></button>
    </div>
    <div class="offcanvas-body">
          <ngx-extended-pdf-viewer [src]="pdfSrc"
          style="width: 100%; height: 100%"
          ></ngx-extended-pdf-viewer>
    </div>
  </ng-template>